import _sfc_main from "./MessageText.vue2.mjs";
/* empty css                  */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("span", _vm._l(_setup.handleTextMessageShowContext(_setup.props.data), function(item, index) {
    return _c("span", { key: index }, [item.name === "text" ? _c("span", { staticClass: "text-box" }, [_vm._v(_vm._s(item.text))]) : item.name === "img" ? _c("img", { staticClass: "text-img", attrs: { "src": item.src } }) : _vm._e()]);
  }), 0);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "98238edd"
);
const MessageText = __component__.exports;
export {
  MessageText as default
};
